import { action, observable, makeObservable } from 'mobx';
import Store from './Store';
import { LOCALSTORAGE_STORAGE } from '@/util/StorageUtil';

/**
 * Configurações para os tipos de mensagens.
 */
export const TIPO_MENSAGEM = {
    PADRAO: { id: 'default', duracaoMinima: 4000 },
    ERRO: { id: 'error', duracaoMinima: 8000 },
    SUCESSO: { id: 'success', duracaoMinima: 4000 },
    ALERTA: { id: 'warning', duracaoMinima: 6000 },
    INFO: { id: 'info', duracaoMinima: 4000 }
};

/**
 * Classe utilizada para guardar e manipular o estado da aplicação.
 * Deve-se criar uma para cada contexto ou entidade.
 */
class MensagemStore extends Store {
    exibir;
    mensagem;

    constructor(props) {
        super(props);

        makeObservable(this, {
            exibir: observable,
            mensagem: observable,
            setExibir: action,
            initMensagem: action,
            abrirMensagem: action,
            abrirMensagemAlerta: action,
            abrirMensagemErro: action,
            abrirMensagemSucesso: action,
            abrirMensagemInfo: action
        });

        this.setExibir(false);
        this.initMensagem();
    }

    get storageType() {
        return LOCALSTORAGE_STORAGE;
    }

    setExibir(exibir) {
        this.exibir = exibir;
    }

    initMensagem() {
        this.mensagem = {
            conteudo: '',
            tipo: TIPO_MENSAGEM.PADRAO.id,
            duracao: TIPO_MENSAGEM.PADRAO.duracaoMinima,
            evitarDuplicacao: false
        };
    }

    abrirMensagem = (conteudo, tipo, duracao, evitarDuplicacao) => {
        const conteudoTexto = Array.isArray(conteudo) ? conteudo.filter(Boolean).join('\n') : conteudo;
        if (!conteudoTexto) {
            return;
        }

        this.mensagem = {
            conteudo: conteudoTexto,
            tipo: tipo ? tipo : TIPO_MENSAGEM.PADRAO.id,
            duracao: duracao ? duracao : MensagemStore.calcularDuracao(conteudoTexto, TIPO_MENSAGEM.PADRAO),
            evitarDuplicacao: evitarDuplicacao
        };

        this.exibir = true;
    };

    static calcularDuracao(conteudo, tipoMensagem) {
        if (!conteudo || typeof conteudo !== 'string' || conteudo.length === 0) {
            return tipoMensagem.duracaoMinima;
        }

        const palavras = conteudo.trim().split(/\s/).length + 1;
        const MEDIA_LEITURA_PALAVRAS_POR_SEGUNDO = 3;
        const UM_SEGUNDO = 1000;
        const duracao = UM_SEGUNDO + Math.ceil((palavras / MEDIA_LEITURA_PALAVRAS_POR_SEGUNDO) * UM_SEGUNDO);

        return Math.max(tipoMensagem.duracaoMinima, duracao);
    }

    abrirMensagemAlerta = (conteudo, duracao, evitarDuplicacao = true) => {
        this.abrirMensagem(
            conteudo,
            TIPO_MENSAGEM.ALERTA.id,
            duracao ? duracao : MensagemStore.calcularDuracao(conteudo, TIPO_MENSAGEM.ALERTA),
            evitarDuplicacao
        );
    };

    abrirMensagemErro = (conteudo, duracao, evitarDuplicacao = true) => {
        this.abrirMensagem(
            conteudo,
            TIPO_MENSAGEM.ERRO.id,
            duracao ? duracao : MensagemStore.calcularDuracao(conteudo, TIPO_MENSAGEM.ERRO),
            evitarDuplicacao
        );
    };

    abrirMensagemSucesso = (conteudo, duracao, evitarDuplicacao = true) => {
        this.abrirMensagem(
            conteudo,
            TIPO_MENSAGEM.SUCESSO.id,
            duracao ? duracao : MensagemStore.calcularDuracao(conteudo, TIPO_MENSAGEM.SUCESSO),
            evitarDuplicacao
        );
    };

    abrirMensagemInfo = (conteudo, duracao, evitarDuplicacao = true) => {
        this.abrirMensagem(
            conteudo,
            TIPO_MENSAGEM.INFO.id,
            duracao ? duracao : MensagemStore.calcularDuracao(conteudo, TIPO_MENSAGEM.INFO),
            evitarDuplicacao
        );
    };
}

export default MensagemStore;
